import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {


  @ViewChild('mep')
  mep: ElementRef;

  scroll_y: number;
  searchTerm: String;

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    this.scroll_y = event.currentTarget.scrollY
  }

  selectedFAQ = [];
  CollapsedHeight: string = '50px';
  ExpandedHeight: string = '50px';

  contentList = [
    {
      title: 'Frequently Asked Questions',
      titleAbbreviated: 'FAQ',
      faq: [
        {
          question: `How are wells selected to report injection data?`,
          answer: `The Railroad Commission of Texas (RRC) has issued a Notice to Operators requesting certain SWDs to report to the TexNet Injection/Pressure Reporting Tool to assist the RRC in monitoring and responding to injection and reservoir conditions that may be conducive to induced seismicity or resulting in excessive reservoir pressures. RRC staff may also request operators by letter to report data to the Tool, typically because a well falls within an RRC-defined Seismic Investigation Region (SIR). More information on how RRC responds to seismicity can be found  <a href="https://www.rrc.texas.gov/oil-and-gas/applications-and-permits/injection-storage-permits/oil-and-gas-waste-disposal/injection-disposal-permit-procedures/seismicity-review/seismicity-response/">here.</a>`
        },
        {
          question: `Am I requested to submit injection volume and pressure information to the TexNet Injection/Pressure Reporting Tool?`,
          answer: `Per the <a href="https://www.rrc.texas.gov/media/sm5bzzpg/nto-disposal-well-monitoring-reporting-requirements-in-the-permian-basin-12-19-2023.pdf" target="_blank" title="Link to December 2023 NTO">December 2023 Notice to Operators</a>, if you are the operator of an SWD within the greater Permian Basin (Oil and Gas Districts 7C, 8, and 8A, and Fisher County in District 7B) with a permitted injection rate of 5,000 barrels / day or greater, you are requested to submit data to the TexNet Injection/Pressure Reporting Tool. Any other operator will be requested to report data to the Tool by a letter from RRC staff. If you’re still not sure if you are requested to report data to the Tool, you may contact the RRC at <a href="mailto:uic@rrc.texas.gov" title="Link to email RRC UIC Team">uic@rrc.texas.gov</a>.`
        },
        {
          question: `I am having technical difficulties submitting data to the Texnet Injection/Pressure Reporting Tool.  Who can I contact for help?`,
          answer: `For help using the application, please contact Aaron Averett at <a href="mailto:aaron.averett@beg.utexas.edu">aaron.averett@beg.utexas.edu</a> and CC the TexNet main email account at <a href="texnet@beg.utexas.edu">texnet@beg.utexas.edu</a>.`
        },
        {
          question: `I have regulatory questions regarding the reporting requirements.  Who can I contact to get these answered?`,
          answer: `For answers to policy questions related to the Tool, please contact staff of the Railroad Commission of Texas at <a href="uic@rrc.texas.gov" title="Link to email RRC UIC Team">uic@rrc.texas.gov</a>.`
        },
        {
          question: `A well I am requested to report on does not appear in my list of wells.  How do I get this fixed?`,
          answer: `This can happen for several reasons.  Before requesting support, please try the following:`,
          list: [
            'Make sure that you have properly filed the paperwork to document this change with RRC and that that paperwork has been processed.',
            `Make sure that you have cleared any search parameters you have previously entered while searching for other wells, including the “Exclude zero” checkbox`,
            `If you are sure that the required paperwork has been processed and you have cleared all of the search parameter fields, contact us for support.`]
        },
        {
          question: `If I need help using the application, or have a question not listed here, who can I contact?`,
          answer: `To request support with using the TexNet Injection/Pressure Reporting Tool, send an email to the TexNet Team at <a href="texnet-web-support@beg.utexas.edu">texnet-web-support@beg.utexas.edu</a>.`
        }
      ]
    },
    {
      title: 'Reporting Field Glossary',
      titleAbbreviated: 'Glossary',
      faq: [
        {
          question: `Volume Injected (Bbls)`,
          answer: `The volume of liquid injected during the reporting day, in barrels.`
        },
        {
          question: `Injection Pressure Average (PSIG)`,
          answer: `This is the average surface injection pressure measured during the reporting day at the well head, in PSIG.`
        },
        {
          question: `Injection Pressure Max (PSIG)`,
          answer: `This is the maximum surface injection pressure measured during the reporting day at the well head, in PSIG.`
        },
        {
          question: `Injection Rate Max. (Bbl/min)`,
          answer: `The maximum instantaneous injection rate measured during the reporting day, in barrels per minute.<br /><br />The December 2023 NTO states that all new and amended permits will require reporting the maximum injection rate. Similarly, existing SWDs with permitted maximum daily injection volumes greater than 5,000 bbls within the Greater Permian Basin are requested to report the same parameter.  If the well is not equipped with monitors that report a near-instantaneous maximum injection rate, RRC requests that the operator estimate it by dividing the volume injected by the number of minutes the well was injecting. <br /> <br /> For example, your estimated maximum injection rate would be 6.94 BPM if you injected 10,000 bbls and the well was injecting for that entire reporting day: 10,000 bbls per day ÷ 1440 minutes per day = 6.94 barrels per minute.`
        },
        {
          question: `Total Gas Volume Injected (MCF)`,
          answer: `The total volume of gas injected during the reporting day, in MCF.`
        },
        {
          question: `Max Day Inj Gas Rate (Mcf/min)`,
          answer: `The maximum instantaneous rate of gas injection during the reporting day, in standard cubic feet per minute on the reporting day.<br /><br />The December 2023 NTO states that all new and amended permits will require reporting the maximum injection rate. Similarly, existing SWDs with permitted maximum daily injection volumes greater than 5,000 bbls within the Greater Permian Basin are requested to report the same parameter.  If the well is not equipped with monitors that report a near-instantaneous maximum injection rate, RRC requests that the operator estimate it by dividing the volume injected by the number of minutes the well was injecting.<br /><br />For example, your estimated maximum injection rate would be 6.94 Mcf/min if you injected 10,000 Mcf/day and the well was injecting for that entire reporting day: 10,000 Mcf/day ÷ 1440 minutes per day = 6.94 Mcf/min.`
        },
        {
          question: `Annulus Pressure Num. Readings`,
          answer: `The number of annulus pressure readings taken that contributed to the minimum and maximum.`
        },
        {
          question: `Annulus Pressure Min. (PSIG)`,
          answer: `The lowest annulus pressure reading taken during the given day.`
        },
        {
          question: `Annulus Pressure Max. (PSIG)`,
          answer: `The highest annulus pressure reading taken during the given day.`
        },
        {
          question: `Completed Injection Interval Top (perforated or open hole interval) (Ft.)`,
          answer: `The TVD below ground surface of the top of the injection interval on the given day.`
        },
        {
          question: `Completed Injection Interval Bottom (perforated or open hole interval) (Ft.)`,
          answer: `The TVD below ground surface of the bottom of the injection interval on the given day.`
        },
        {
          question: `Depth of Tubing Packer (Ft.)`,
          answer: `The TVD below ground surface of the tubing packer.`
        },
        {
          question: `Formations`,
          answer: `This is the set of formations that are being injected into on the reporting day.`
        },
        {
          question: `Injected Fluids from Other Sources`,
          answer: `This field indicates whether the fluids being injected are from sources other than the reporting operator.`
        },
        {
          question: `Injection Through...`,
          answer: `This field should contain either "Tubing" or "Casing," indicating which set of tubulars the fluids are being injected through.`
        },
        {
          question: 'Shut-In Bottom Hole Pressure',
          answer: 'This is the static pressure, as measured at the bottom of the well.  All pressure measurements in TexNet Injection/Pressure reporting tool are reported in PSIG.  The Tool accepts three different methods for measuring or calculating the shut-in bottom hole pressure, which are described in the December 2023 Notice to Operators.'
        },
        {
          question: 'Pressure calculated to top of completed interval TVD',
          answer: 'This is the TVD (true vertical depth) in feet below ground surface of the sensor used to measure the bottom hole pressure, when reporting the shut-in BHP.'
        },
        {
          question: 'Liquid Density',
          answer: 'This is the density of the fluid being injected into the well in pounds per gallon.  It must be between 5 lb/gal and 20 lb/gal.'
        },
        {
          question: 'MEAS BHP AVE INJ (PSIG)',
          answer: 'This is the average bottomhole injection pressure when reporting a measured bottom hole pressure on the reporting day.'
        },
        {
          question: 'MEAS BHP MAX INJ (PSIG)',
          answer: 'This is the maximum bottomhole injection pressure when reporting a measured bottom hole pressure on the reporting day.'
        },
        {
          question: 'CALC BHP AVE INJ (PSIG)',
          answer: 'This is the calculated average bottomhole injection pressure value which is obtained by using a measured surface injection pressure, estimate for the hydrostatic head of the fluid column, and an estimate of friction loss using the size of the tubulars and the injection rate. '
        },
        {
          question: 'CALC BHP MAX INJ (PSIG)',
          answer: 'This is the calculated maximum bottomhole injection pressure value which is obtained by using a measured surface injection pressure, estimate for the hydrostatic head of the fluid column, and an estimate of friction loss using the size of the tubulars and the injection rate.'
        },
        {
          question: 'STATIC P SHUTIN TIME (Hrs)',
          answer: 'This is length of time in hours that the well was shut-in prior to measuring a static shut-in pressure.'
        }
      ]
    }
    
  ]

  constructor() { }

  ngOnInit(): void {

    //sort the glossary terms, so they're in alphabetical order
    this.contentList[1].faq.sort((a: any, b: any) => {
      let ret = 0;

      if(a.question > b.question) {
        ret = 1;
      }
      else if(a.question < b.question) {
        ret = -1;
      }

      return ret;
    });
  }

  scroll(title, index) {
    let matchedElement = document.getElementById(title + '-' + index);
    matchedElement.scrollIntoView({
      behavior: 'smooth'
    });
  }

}
